import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../../modal";
import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {Breadcrumb, Button, Form, Input, notification, Select, Space, Spin, Transfer} from "antd";
import DB_Route from "../../../../database/dictionary/route";
import axios from "axios";
import DB_Branch from "../../../../database/dictionary/branch";
import DB_OrgStructure from "../../../../database/dictionary/org_structures";
import DB_TradePoint from "../../../../database/dictionary/trade-point";
import {DebounceSelect} from "../../../tech/search_input";
import {isNull} from "../../../tech/check_string";
import BackButton from "../../../tech/back_button";

const EditTRoute = () => {
    const {token, setToken} = useContext(Context);
    const {route_id} = useParams()
    const {getRoute, statusRoute, saveRoute, updateRoute, dependRoute} = DB_Route(token);
    const {getActiveBranches} = DB_Branch(token);
    const {getOrgStructureFilter} = DB_OrgStructure(token)
    const {getOrgStructures, getBranchesForOrgStructure} = DB_OrgStructure(token);
    const {getTradePointsForOrgStructure} = DB_TradePoint(token);
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const location = useLocation()
    const path = location.state == null ? null : (location.state.path == null ? null : location.state.path)

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [wait, setWait] = useState(true);
    const [isActive, setIsActive] = useState();
    const [isLoadSystem, setIsLoadSystem] = useState(true);
    const [branch, setBranch] = useState([]);
    const [orgStructure, setOrgStructure] = useState([]);
    const [selectedOrgStructure, setSelectedOrgStructure] = useState();
    const [disableBranch, setDisableBranch] = useState(true);
    const [selectedBranch, setSelectedBranch] = useState();
    const [disableTradePoint, setDisableTradePoint] = useState(true);

    const [tradePoint, setTradePoint] = useState([]);
    const [selectedTradePoint, setSelectedTradePoint] = useState([]);

    const openNotificationFailed = (action) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_update_create', {action: action, type: t('route').toLowerCase()}),
            placement: 'top'
        });
    };


    // const openNotificationFailedDepend = (what, by) => {
    //     notification.error({
    //         message: t('failed'),
    //         description:
    //             '\n' +
    //             t('e_reference', {what: what, by: by}),
    //         placement: 'top'
    //     })
    // };

    useEffect(() => {
        window.scroll(0, 0)
        if (route_id !== 'new') {
            // if (!isLoadSystem) {
                getRoute(route_id)
                    .then(res => {
                        form.setFieldsValue({
                            code: res.data.code,
                            name: res.data.name,
                            org_structure_id: res.data.org_structure,
                            branch_id: res.data.branch_id,
                            day_of_week: res.data.day_of_week,
                        })
                        setSelectedTradePoint(res.data.trade_points);

                        if (res.data.org_structure_id != null) {
                            setSelectedOrgStructure(res.data.org_structure_id);
                            setDisableBranch(false);
                        }
                        if (res.data.branch_id != null) {
                            setSelectedBranch(res.data.branch_id);
                            setDisableTradePoint(false);
                        }
                    })
                    .catch(e => {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    })
                    .finally(() => {
                        setWait(false)
                    })
        } else {
            setWait(false);
        }
    }, [])

    useEffect(() => {
        axios.all([getActiveBranches()])
            .then(axios.spread((branches, org_structures) => {
                setBranch(branches.data);
            }))
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    errorConnect()
                }
            })
    }, [])

    const onFinish = async (values) => {
        setWait(true);

        const formData = new FormData();
        if (!isNull(values['code'])) {
            formData.append('code', values["code"])
        }
        formData.append('org_structure_id', selectedOrgStructure)
        formData.append('branch_id', values["branch_id"])
        formData.append('day_of_week', values["day_of_week"])
        formData.append('trade_points', selectedTradePoint)

        if (route_id !== 'new') {
            formData.append('id', route_id)
        }

        saveRoute(formData)
            .then(res => {
                if (res.status === 200) {
                    // navigate(path ? `/routes?${path}` : "/routes", {replace: true})
                    navigate(-1)
                } else {
                    openNotificationFailed(t('creating'));
                }
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            });

    }

    useEffect(() => {
        if (selectedOrgStructure != null) {
            setDisableBranch(false);
            const formData = new FormData;
            formData.append('org_structure_id', selectedOrgStructure)

            getBranchesForOrgStructure(formData)
                .then(res => {
                    setBranch(res.data);
                })
                .catch(e => {
                    if (e.response.status === 403) {
                        window.location.reload()
                    }
                    errorConnect()
                })
        } else {
            setDisableBranch(true);
        }
    }, [selectedOrgStructure])

    useEffect(() => {
        if (selectedBranch != null) {
            setDisableTradePoint(false);
            getTradePointsForOrgStructure(selectedBranch, selectedOrgStructure)
                .then(res => {
                    setTradePoint(res.data);
                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })
        } else {
            setDisableTradePoint(true);
        }
    }, [selectedBranch])

    const filterOption = (inputValue, option) => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 || option.address.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;

    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>
                                {t('route')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton/>
                        <Button shape="round" type="primary" htmlType="submit" form={"form"}
                                key='2'>{route_id === 'new' ? t('create') : t('update')}</Button>
                    </Space>
                </Space>

                <Form form={form}
                      labelCol={{
                          span: 8
                      }}
                      wrapperCol={{
                          span: 10
                      }}
                      layout={"vertical"}
                      onFinish={onFinish}
                      autoComplete="off"
                      id={"form"}
                >

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="code"
                               label={t('code')}
                    >
                        <Input showCount maxLength={100}/>
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="org_structure_id"
                               label={t('org_structure')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_select', {select: t('org_structure').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >
                        <DebounceSelect
                            showSearch
                            fetchOptions={getOrgStructureFilter}
                            onChange={newValue => setSelectedOrgStructure(newValue.value)}
                        />
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="branch_id"
                               label={t('branch')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_select', {select: t('branch').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >
                        <Select
                            showSearch
                            optionFilterProp="name"
                            optionLabelProp="name"
                            disabled={disableBranch}
                            onChange={e => setSelectedBranch(e)}
                        >
                            {branch.map(c =>
                                <Select.Option key={c.id} value={c.id} name={c.name}
                                               disabled={c.status === 0}>{c.name}</Select.Option>
                            )}
                        </Select>
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="day_of_week"
                               label={t('day_of_week')}
                               initialValue={0}
                    >
                        <Select>
                            <Select.Option key={0} value={0}>{t('no_reference_to_the_day')}</Select.Option>
                            <Select.Option key={1} value={1}>{t('monday')}</Select.Option>
                            <Select.Option key={2} value={2}>{t('tuesday')}</Select.Option>
                            <Select.Option key={3} value={3}>{t('wednesday')}</Select.Option>
                            <Select.Option key={4} value={4}>{t('thursday')}</Select.Option>
                            <Select.Option key={5} value={5}>{t('friday')}</Select.Option>
                            <Select.Option key={6} value={6}>{t('saturday')}</Select.Option>
                            <Select.Option key={7} value={7}>{t('sunday')}</Select.Option>
                        </Select>
                    </Form.Item>

                </Form>

                <p style={{marginTop: '20pt', color: '#000000d9'}}>{t('trade_points')}</p>
                <Transfer
                    dataSource={tradePoint}
                    rowKey={item => item.id}
                    titles={[t('all'), t('selected')]}
                    showSearch
                    filterOption={filterOption}
                    targetKeys={selectedTradePoint}
                    onChange={e => setSelectedTradePoint(e)}
                    render={item => <>{item.name}<br/>{item.address}</>}
                    style={{marginTop: '10pt'}}
                    disabled={disableTradePoint}
                    listStyle={{background: '#fff'}}
                    oneWay={true}
                    pagination={false}
                />
            </div>
            <Outlet/>
        </Spin>
    )
}

export default EditTRoute;